export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6765.9d0865e9.jpg";